<div class="new-project-container">
  <div
    style="border-bottom: 1px solid rgba(222, 222, 222, 0.2);padding-bottom:19px;display: flex;justify-content:flex-end;">
    <img src="./assets/images/close.png" class="close-image" routerLink='../projects'>
  </div>
  <div style="display: flex; align-items: center; padding: 32px 64px;color: #DEDEDE;">
    <h4 style="margin-top: 0; margin-bottom: 0">New Project</h4>

  </div>
  <div style="width: 100%; background: white">
    <app-basic-info></app-basic-info>
  </div>
</div>